import styled from 'styled-components';

export default styled.div`
	width: ${props => props.width || '100%'}
	
	&:after {
		content: "";
		display: block;
		padding-bottom: 100%;
	}
`;


// WEBPACK FOOTER //
// ./src/components/responsive-square.js